import React from "react";
import { X } from "lucide-react";
import { Button } from "components/ui/button";

type KeywordNoResultsProps = {
    message: string;
    resetLabel: string;
    onReset: () => void;
};

const KeywordNoResults: React.FC<KeywordNoResultsProps> = ({ message, resetLabel, onReset }) => (
    <div className="flex flex-col items-center gap-3">
        <span>{message}</span>
        <Button type="button" variant="outline" className="h-10 rounded-2xl" onClick={onReset}>
            <X aria-hidden="true" className="mr-2 h-4 w-4" />
            {resetLabel}
        </Button>
    </div>
);

export default KeywordNoResults;
